import React from "react";
import Heading from "./common/Heading";
import CardWithDetail from "./CardWithDetail";
import { useSiteContent } from "../content/SiteContentContext.jsx";

/**
 * Showcase de la portada: un bloque por CATEGORÍA de oferta, derivado de los datos (los distintos
 * `section` presentes en academicDegrees, en su orden de aparición). Así, agregar una categoría nueva
 * (p.ej. doctorados) desde el panel la muestra también aquí, sin tocar código. El título de cada bloque
 * se toma del menú (navLinks) si existe.
 */
const HAbout = () => {
  const { academicDegrees, navLinks } = useSiteContent();

  const sections = [];
  (academicDegrees || []).forEach((offer) => {
    if (offer.section && !sections.includes(offer.section)) {
      sections.push(offer.section);
    }
  });

  const titleFor = (section) => {
    const nav = (navLinks || []).find((n) => n.link === `/${section}`);
    return nav?.title || section.charAt(0).toUpperCase() + section.slice(1);
  };

  return (
    <section className="homeAbout">
      {sections.map((section) => (
        <div key={section} className="mx-auto max-w-[95%] mt-10 p-6 rounded-lg shadow">
          <Heading subtitle={titleFor(section)} title={`Nuestra oferta de ${titleFor(section)}`} />
          <CardWithDetail section={section} />
        </div>
      ))}
    </section>
  );
};

export default HAbout;
